import React from 'react';

import {
  getSession, isAuth,isAdminAuth,isOrgAdminAuth, login,adminLogin, logout, sendPasswordReset, addUser, getUsers,verify2FA
} from '../services/AuthService';

const AuthContext = React.createContext(null);

function AuthProvider({ children, ...rest }) {
  // AuthContext to encapsulate these functions, which are wrappers to the services service.
  const auth = {
    getSession,
    isAuth,
    isAdminAuth,
    isOrgAdminAuth,
    login,
    adminLogin,
    logout,
    sendPasswordReset,
    addUser,
    getUsers,
    verify2FA
  };

  return (
    <AuthContext.Provider value={auth} {...rest}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext };
export default AuthProvider;
